module.exports = __webpack_public_path__ + "static/media/pradnyesh.a835eaf5.jpeg";